import { render, staticRenderFns } from "./sendDocMessage.vue?vue&type=template&id=4d269ffc&scoped=true"
import script from "./sendDocMessage.vue?vue&type=script&lang=js"
export * from "./sendDocMessage.vue?vue&type=script&lang=js"
import style0 from "./sendDocMessage.vue?vue&type=style&index=0&id=4d269ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d269ffc",
  null
  
)

export default component.exports